import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useFitText from "use-fit-text";

import HotLevelIcon from "../hotLevelIcon";
import DesafiosFeedback from "../feedback";
import Timer from "../../timer";

import styles from "./desafiosGame.module.css";

// Player roulette
const FADE_IN_DELAY = 0;

// Card shuffle
const TIMINGS = {
  fade_in: 600,
  sides_start: 300,
  sides_stay: 300,
  shuffle: 400,
  shuffle_amount: 2,
  sides_end: 300,
  center_reveal: 700,
  reveal_delay: 100,
};

function getShuffleTime() {
  return (
    TIMINGS.fade_in +
    TIMINGS.sides_start +
    TIMINGS.sides_stay +
    TIMINGS.shuffle * TIMINGS.shuffle_amount +
    TIMINGS.sides_stay +
    TIMINGS.sides_end +
    TIMINGS.reveal_delay
  );
}

export function StyledText({
  phrase = "",
  userName = "",
  playerOneName = "",
  className = "",
}) {
  const nomeParts = phrase.split(/{nome}/g); // Dividir por {nome}
  const finalParts = []; // Guardar os elementos JSX gerados

  nomeParts.forEach((part, index) => {
    const whoDoesParts = part.split(/{qfaz}/g); // Dividir cada fragmento por {qfaz}

    whoDoesParts.forEach((subPart, subIndex) => {
      finalParts.push(<span key={`qfaz-${index}-${subIndex}`}>{subPart}</span>);

      // Adiciona o jogador 1 (playerOneName) após cada {qfaz}, exceto o último
      if (subIndex < whoDoesParts.length - 1) {
        finalParts.push(
          <span
            key={`qfaz-name-${index}-${subIndex}`}
            className={`${styles.playerCardName}`}
          >
            {playerOneName}
          </span>
        );
      }
    });

    // Adiciona o jogador 2 (userName) após cada {nome}, exceto o último
    if (index < nomeParts.length - 1) {
      finalParts.push(
        <span
          key={`nome-name-${index}`}
          className={`${styles.playerCardName} `}
        >
          {userName}
        </span>
      );
    }
  });
  return (
    <div className={`items-center mb-8 text-2xl font-normal ${className}`}>
      {finalParts}
    </div>
  );
}

function Card({ style, children, timings }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, getShuffleTime());
  }, []);

  return (
    <div className={`${styles.card} ${style}`} style={timings}>
      <div className={`${styles.card_border}`}></div>
      <div className={`${styles.front}`}>
        {children && show ? (
          children
        ) : (
          <>
            <div className="h-[29px]"></div>
            <div className={styles.hr} />
          </>
        )}
      </div>
      <div className={styles.back}>
        <div className="h-[29px]"></div>
        <div className={styles.hr} />
      </div>
    </div>
  );
}

function ChallengeCard({ player1, player2, challenge }) {
  const { fontSize, ref } = useFitText();

  const side_cards = {
    "--initial-fade": `${TIMINGS.fade_in}ms`,
    "--card-start": `${TIMINGS.sides_start}ms`,
    "--card-stay": `${TIMINGS.sides_stay}ms`,
    "--card-shuffle": `${TIMINGS.shuffle}ms`,
    "--card-shuffle-ammount": TIMINGS.shuffle_amount,
    "--card-end": `${TIMINGS.sides_end}ms`,
  };

  const center_card = {
    "--initial-fade": `${TIMINGS.fade_in}ms`,
    "--initial-stay": `${TIMINGS.sides_start + TIMINGS.sides_stay}ms`,
    "--card-shuffle": `${TIMINGS.shuffle}ms`,
    "--card-shuffle-ammount": TIMINGS.shuffle_amount,
    "--card-stay": `${TIMINGS.sides_stay + TIMINGS.sides_end}ms`,
    "--card-end": `${TIMINGS.center_reveal}ms`,
  };

  return (
    <div className={styles["card-container"]}>
      <Card
        style={`${styles["card-animation-sides"]} ${styles["card-animation-left"]}`}
        timings={side_cards}
      />
      <Card
        style={`${styles["card-animation-sides"]} ${styles["card-animation-right"]}`}
        timings={side_cards}
      />
      <Card style={`${styles["card-animation-center"]}`} timings={center_card}>
        <div className="flex flex-col h-full">
          <div className="flex justify-between">
            <div className="w-[calc(100%-110px)]">
              <p ref={ref} style={{ fontSize }} className="font-bold text-xl">
                {challenge?.categoria?.label || ""}
              </p>
            </div>
            <div className="flex w-[110px]">
              {[1, 2, 3, 4, 5].map((i) => {
                return (
                  <HotLevelIcon
                    key={i}
                    size={18}
                    className="ps-1 pb-1"
                    active={challenge?.hot_level || 0 >= i}
                  />
                );
              })}
            </div>
          </div>
          <div className={styles.hr} />
          <div className="flex-1 flex flex-col">
            <div className="flex justify-center mt-1">
              <span className="font-bold text-xl">{player1.name}</span>
            </div>
            <div className="flex-1 flex items-center scroll">
              <StyledText
                // className="max-h-0"
                phrase={challenge?.desafio || ""}
                userName={player2.name}
                playerOneName={player1.name}
              />
            </div>
          </div>
          {challenge?.duracao ? (
            <div className="flex justify-center mt-4">
              <Timer timer={challenge.duracao} />
            </div>
          ) : null}
        </div>
      </Card>
    </div>
  );
}

export default function DesafiosCardGame({
  roulette_duration,
  handleNext,
  player1,
  player2,
  challenge,
  loading,
}) {
  const [show, setShow] = useState(false);
  const [showBottom, setShowBottom] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    setShow(false);
    setShowBottom(false);
    setTimeout(() => {
      setShow(true);
      setTimeout(() => {
        setShowBottom(true);
      }, getShuffleTime() + TIMINGS.center_reveal + 50);
    }, roulette_duration + FADE_IN_DELAY);
  }, [player1, player2]);

  return show ? (
    <div
      className={styles.container}
      style={{ "--container-fade-in": `${TIMINGS.fade_in}ms` }}
    >
      <div className="pe-20 ps-20">
        <div className="flex justify-center mt-[-60px]">
          <div className={`${styles.player}`}>
            <img
              className="bg-[--primary-dark] object-cover"
              src={`https://desafios-picantes-bucket.dev12br.com${player1.image}`}
              alt=""
            />
            <div className="flex justify-center mt-2">
              <span>{player1.name}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1 flex justify-center items-center">
        <ChallengeCard
          player1={player1}
          player2={player2}
          challenge={challenge}
        />
      </div>
      <div
        className={`${styles.bottom} ${showBottom ? "" : "opacity-0"}`}
        style={{
          "--animation-delay": `${getShuffleTime() + TIMINGS.center_reveal}ms`,
        }}
      >
        {!challenge?.custom ? (
          <div className="mb-4">
            <DesafiosFeedback
              id={challenge.id}
              likes={challenge.like}
              deslikes={challenge.dislike}
            />
          </div>
        ) : (
          <div className="h-11"></div>
        )}
        <div>
          <button
            disabled={loading}
            type="button"
            onClick={handleNext}
            className="btn btn-small btn-brand w-full pt-2 pb-2"
          >
            {t("next")}
          </button>
        </div>
      </div>
    </div>
  ) : null;
}
